// CSS
import './styles/main/index.css';

// React and requests
import React, { useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import API from "./api/API";

// Component imports
import Menu from "./components/Menu";
import Login from "./components/User/Login";
import Register from "./components/User/Register";
import Account from "./components/User/Account";
import FileBrowser from "./components/FileBrowser/FileBrowser";
import Home from "./components/Home";
import PageNotFound from "./components/PageNotFound";
import AdminHome from "./components/Admin/AdminHome";
import AdminLogin from "./components/Admin/AdminLogin";
import {UserEnabledRoute, AdminEnabledRoute, UserNotEnabledRoute, NotUserRoute} from "./ProtectedRoutes";
import VerificationAwaiting from "./VerificationAwaiting";

import OnlyOfficeEditor from "./components/FileEditor/OnlyOffice";

const App = () => {

  const pageVariants = {
    initial: {
      opacity: 0,
      x: "-100vw",
    },
    in: {
      opacity: 1,
      x: 0,
    },
    out: {
      opacity: 0,
      x: "100vw",
    },
  };
  
  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.5,
  };

  useEffect(() => {
    // Add IP address (with a fallback)
    API.addIpAddress().then((result) => {
      if (!result) API.addIpAddress(2);
    });
  }, []);

  return (
    <div className="bg-primary w-full overflow-hidden min-h-[100dvh]">
      {/* Navigation Menu */}
      <Menu />

      {/* Main Content Wrapper with top padding */}
      <div>        
        <AnimatePresence exitBeforeEnter>
          <Routes>

            <Route path="/editor" element={
                <motion.div
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <OnlyOfficeEditor />
                </motion.div>
            }/>

            {/* Routes only accessible if logged in and account enabled */}
            <Route element={<UserEnabledRoute />}>
              <Route path="/account/:id" element={
                <motion.div
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <Account />
                </motion.div>
              } />
              <Route path="/browser/*" element={
                <motion.div
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <FileBrowser />
                </motion.div>
              } />
            </Route>

            {/* Routes only accessible if logged in as admin and account enabled */}
            <Route element={<AdminEnabledRoute />}>
                <Route path="/admin" element={
                  <motion.div
                    initial="initial"
                    animate="in"
                    exit="out"
                    variants={pageVariants}
                    transition={pageTransition}
                  >
                    <AdminHome />
                  </motion.div>
                } />
            </Route>
            
            <Route element={<UserNotEnabledRoute />}>
              <Route path="/verification" element={
                <motion.div
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <VerificationAwaiting />
                </motion.div>
              } />
            </Route>

            <Route element={<NotUserRoute />}>
              <Route path="/login" element={
                <motion.div
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <Login />
                </motion.div>
              } />
              <Route path="/register" element={
                <motion.div
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <Register />
                </motion.div>
              } />            
              <Route path="/admin/login" element={
                <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
              >
                <AdminLogin />
              </motion.div>
              } />
            </Route>
            
            <Route path="/" element={
                <motion.div
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <Home />
                </motion.div>
            } />

            <Route path="*" element={
                <motion.div
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                >
                  <PageNotFound />
                </motion.div>
            } />
          </Routes>        
        </AnimatePresence>
      </div>
    </div>
  );
};

export default App;